export function isVerifiedFlag(value: unknown): boolean {
  return value === true || value === 'true' || value === 1;
}

export function getDashboardPath(role?: string | null, isShs?: boolean | null): string {
  if (role === 'admin') return '/admin-dashboard';
  if (role === 'instructor') return '/instructor-dashboard';
  if (isShs || role === 'shs_student') return '/shs-dashboard';
  return '/student-dashboard';
}

export function resolveRoleFromMetadata(user: {
  user_metadata?: Record<string, unknown> | null;
  app_metadata?: Record<string, unknown> | null;
}): string {
  const meta = user.user_metadata || {};
  const appMeta = user.app_metadata || {};
  const role = meta.role || appMeta.role || 'student';
  return String(role);
}

export function isShsFromMetadata(user: {
  user_metadata?: Record<string, unknown> | null;
}): boolean {
  return Boolean(user.user_metadata?.is_shs_student);
}

export function isVerifiedFromMetadata(user: {
  user_metadata?: Record<string, unknown> | null;
}): boolean {
  return isVerifiedFlag(user.user_metadata?.email_verified);
}

export function normalizeVerifyResult(rpcResult: unknown): string {
  if (typeof rpcResult === 'string') return rpcResult;
  if (rpcResult && typeof rpcResult === 'object') {
    const obj = rpcResult as Record<string, unknown>;
    const nested = obj.verify_email_code ?? obj.result ?? obj.status;
    if (typeof nested === 'string') return nested;
  }
  return '';
}

export function withTimeout<T>(promise: PromiseLike<T>, ms: number, message = 'Request timed out'): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(message)), ms);
    Promise.resolve(promise).then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}
